'use strict';

import * as Onyx from '../lib/onyx.min.js';

export default class Background extends Onyx.Entity {
    constructor({ model = "track_1.obj", caustic = null, godrays = null } = {}){
        super(...arguments);

        Onyx.ImportModelFromOBJ.load({src: "res/models/" + model}).then((model) => {
            this.addComponent(model);

            model.meshes[0].material.lighting = 0;
            model.meshes[0].material.shadowCastingMode = 0;
            model.meshes[0].material.shadowBias = 0.001;

            model.meshes[0].material.buildProgram();
        });
    }
}